import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const VehicleMaintenancePolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  maintenanceProviderContact,
  fleetManagerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Vehicle_Maintenance_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Vehicle Maintenance Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        This policy outlines the procedures and legal requirements for maintaining the company’s vehicles to ensure safety, reliability, and regulatory compliance.
      </p>

      <h4 className="section-title">2. Legal Maintenance Provider Requirements</h4>
      <p className="section-content">
        All maintenance work must be conducted by qualified and authorised maintenance providers as required under relevant UK legislation, including the Road Traffic Act and the Operator Licensing regulations.
      </p>
      <p className="section-content">
        Maintenance providers must hold valid accreditation and be competent to service, inspect, and repair vehicles to the standards required by law.
      </p>

      <h4 className="section-title">3. Planned Preventative Maintenance (PPM) / Maintenance Inspections (PMI)</h4>
      <ul>
        <li>Vehicles must be maintained in accordance with manufacturer’s schedules and legal requirements through a Planned Preventative Maintenance programme.</li>
        <li>Scheduled Maintenance Inspections (PMIs) must be performed at specified intervals to identify and rectify defects before they impact vehicle safety or compliance.</li>
        <li>All maintenance activities, including PMIs, must be documented and recorded for audit and compliance purposes.</li>
      </ul>

      <h4 className="section-title">4. Daily Driver Walkaround Checks</h4>
      <ul>
        <li>Drivers are responsible for conducting daily walkaround checks before vehicle use, inspecting key safety components such as tyres, brakes, lights, steering, and fluid levels.</li>
        <li>Any defects or irregularities found must be reported immediately through the company’s defect reporting system.</li>
        <li>Drivers must not operate vehicles that are deemed unsafe or have outstanding defects that affect safety or legality.</li>
      </ul>

      <h4 className="section-title">5. Maintenance Scheduling and Record Keeping</h4>
      <ul>
        <li>A comprehensive maintenance schedule must be developed and adhered to, covering all vehicles in the fleet.</li>
        <li>Maintenance records must be kept accurately and retained in line with legal requirements, including repair details, inspection reports, and defect rectification.</li>
        <li>The company will ensure timely follow-up on all maintenance activities to prevent vehicle downtime and maintain fleet availability.</li>
      </ul>

      <h4 className="section-title">6. Roles and Responsibilities</h4>
      <p className="section-content"><strong>Maintenance Provider:</strong> Responsible for delivering maintenance services in accordance with legal and manufacturer standards. Contact: {maintenanceProviderContact || "[Insert Contact]"}</p>
      <p className="section-content"><strong>Fleet Manager:</strong> Oversees maintenance scheduling, record keeping, and compliance. Contact: {fleetManagerContact || "[Insert Contact]"}</p>
      <p className="section-content"><strong>Drivers:</strong> Conduct daily walkaround checks and report defects promptly.</p>

      <h4 className="section-title">7. Review and Continuous Improvement</h4>
      <p className="section-content">
        This policy and maintenance processes will be reviewed regularly to ensure effectiveness, compliance with changing legislation, and continuous improvement.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and will comply with the Vehicle Maintenance Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default VehicleMaintenancePolicy;
